import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.onFullscreenChange = this.toggleButtonVisibility.bind(this)
    document.addEventListener("fullscreenchange", this.onFullscreenChange)
    this.toggleButtonVisibility()
  }

  disconnect() {
    document.removeEventListener("fullscreenchange", this.onFullscreenChange)
  }

  toggle(e) {
    e.preventDefault()
    if (!document.fullscreenElement) {
      if (!document.documentElement.requestFullscreen) return
      document.documentElement.requestFullscreen().catch((err) => {
        console.error(`Error attempting to enable fullscreen: ${err.message}`)
      })
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      }
    }
  }

  toggleButtonVisibility() {
    this.buttonTarget.hidden = !document.documentElement.requestFullscreen
    if (document.fullscreenElement) {
      this.buttonTarget.classList.add("opacity-0", "pointer-events-none")
    } else {
      this.buttonTarget.classList.remove("opacity-0", "pointer-events-none")
    }
  }
}
